import { useWindowEventListener } from '../../hooks/useWindowEventListener';
import { ChevronDownIcon, RemoveIcon } from '../../assets/icons';
import { MouseEvent, useState } from 'react';
import styles from './style.module.scss';

interface Props {
    label?: string;
    setItem: any;
    idKey: string;
    titleKey: string;
    selectedItem: any;
    disabled?: boolean;
    searchable?: boolean;
    dropDownList?: any[];
    openListOnTop?: boolean;
    errorMessage?: string;
    wrapperClassName?: string;
    containerClassName?: string;
    onClick?: () => void;
    placeholder?: string;
    showSelectedMode?: boolean;
    resetable?: boolean;
    isRequired?: boolean;
    hasError?: boolean;
};

function DropDown(props: Props) {
    const {
        idKey,
        label,
        onClick,
        setItem,
        disabled,
        titleKey,
        searchable,
        resetable,
        hasError,
        placeholder,
        isRequired,
        errorMessage,
        selectedItem,
        dropDownList,
        openListOnTop,
        wrapperClassName,
        showSelectedMode,
        containerClassName,
    } = props;

    const [showList, setShowList] = useWindowEventListener(closeList);
    const [searchTerm, setSearchTerm] = useState('');
    const [selected, setSelected] = useState(false);

    function closeList() {
        setSearchTerm('');
        setShowList(false);
    };

    const clickOnDropDown = () => {
        if (disabled === true) return;
        setShowList(prevState => !prevState);
        setSelected(true);
        onClick && onClick();
    };

    const removeSelected = (e: MouseEvent<SVGSVGElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setItem({ id: '-1', title: 'Select from list' });
    };

    return (
        <div className={`${styles.container} ${containerClassName}`}>
            {label && <span className={styles.label}>{label} {isRequired && <b>*</b>}</span>}
            <div className={`${styles.dropDown} ${wrapperClassName}`}>
                <div
                    onClick={clickOnDropDown}
                    className={styles.dropDown_slot}
                    data-disabled={Boolean(disabled)}
                    data-show-selected={showSelectedMode && selected}
                    data-has-error={hasError || Boolean(errorMessage)}
                >
                    <div
                        data-disabled={Boolean(disabled)}
                        className={styles.dropDown_slot_title}
                        data-item-selected={Boolean(selectedItem)}
                    >
                        <span>
                            {selectedItem ? selectedItem[titleKey] : (placeholder || 'Select from list')}
                        </span>
                        {(resetable && selectedItem && selectedItem[idKey] !== '-1') ?
                            <RemoveIcon fill='#616161' onClick={removeSelected} /> :
                            <ChevronDownIcon width={14} height={14} style={{ marginRight: '6px' }} />}
                    </div>
                </div>
                {dropDownList && showList && (
                    <div
                        className={styles.list}
                        data-open-list-on-top={openListOnTop}
                    >
                        {searchable && <input
                            type='text'
                            autoFocus
                            value={searchTerm}
                            placeholder='Search...'
                            className={styles.searchInput}
                            onClick={e => e.stopPropagation()}
                            onChange={e => setSearchTerm(e.target.value)}
                        />}
                        <ul>
                            {dropDownList.filter(i => i[titleKey]?.toLowerCase()?.includes(searchTerm.toLowerCase()))?.map(item => {
                                return (<li
                                    className={styles.selected}
                                    onClick={() => setItem(item)}
                                    key={item[idKey]}
                                >
                                    {item[titleKey]}
                                </li>)
                            })}
                        </ul>
                    </div>
                )}
            </div>
            {errorMessage && (<span className={styles.warning}>{errorMessage}</span>)}
        </div>
    );
};

export default DropDown;
